import React from 'react';
import { useTranslation } from 'react-i18next';
import IndicatorsAsideMenu from './IndicatorsAsideMenu';

const IndicatorsAside = () => {
  const { t } = useTranslation();

  return (
    <div className="aside-secondary d-flex flex-row-fluid" style={{ height: '100vh' }}>
      <div className="aside-workspace scroll scroll-push my-2">
        <div className="tab-content d-flex flex-column h-100">
          <div className={`tab-pane p-3 px-lg-6 py-lg-2 fade show active`}>
            <div className={'mb-4 mt-2'}>
              <h3>{t('indicators')}</h3>
            </div>
          </div>
          <IndicatorsAsideMenu />
        </div>
      </div>
    </div>
  );
};

export default IndicatorsAside;
